module.exports = __webpack_public_path__ + "media/images/common/2column_product_bg_ny-6a83db5865e2f82f7efb22e51ac4c478.png";